var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.color)?_c('span',{staticClass:"template-color-chip",style:({ backgroundColor: _vm.color }),attrs:{"data-testid":"template-color-chip"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }